import { Component, OnInit, ViewChild,HostListener, ElementRef,Renderer2} from '@angular/core';
import { Router, Route, ActivatedRoute } from "@angular/router";
import { HelperService, AppSettings, AuthenticationService, Getunitdetails, Agents } from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Base64Pipe } from '../../../services/pipes/base64/base64.pipe';
import { Options, LabelType } from '@angular-slider/ngx-slider';
import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-customer-orders',
  templateUrl: './customer-orders.component.html',
  styleUrls: ['./customer-orders.component.css']
})
export class CustomerOrdersComponent implements OnInit {

  @ViewChild('myPond') myPond: any
  @ViewChild('Writer_Pond_Attach') Writer_Pond_Attach: any
  @ViewChild('Writer_Pond_Plag') Writer_Pond_Plag: any


  public writersRegion            : any = AppSettings.writersRegion;
  public orderStatus              : any = AppSettings.orderStatus;
  public validInvalidSales        : any = AppSettings.validInvalidSales;
  public loading                  : any = false;
  public paginatePage             : any;
  public custId                   : any;
  public leads                    : any = [];
  public leads_Copy               : any = [];
  public checkedClass             : any = false;
  public agents                   : any;
  public select2Agents            : any = [];
  public qaComments               : any = [];
  public agentsSub                : any;
  public qa                       : any;
  public writers                  : any;
  public routerSubscription       : any;
  public activeUser               : any = false;
  public verifiedLoader           : any = false;
  public verifiedStatusOrderId    : any = false;
  public markVerifiedStatus       : any = false;

  public loader:any = false;
  public qaLoader:any = false;
  public comments:any = false;
  public agentComments:any = false;
  public qaRating:any = false;
  public rating_val : any;
  public qa_feedback_note : any;
  public addCommentForm: FormGroup;
  public submitted: any = false;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  public dtOptions: DataTables.Settings = {};
  public dtTrigger: any = new Subject();

  public maxPriceLabel = { name: 'Any', value: 10000 };
  public searchParams: any = { emailId: '', orderStatus: null, agent_id: [], date_from: '', date_to: '', min_amount: 0, max_amount: this.maxPriceLabel.value, verified_sales: null };
  public fullRangeDate: any;
  public base64Pipe: any = new Base64Pipe;

  options: Options = {
    floor: 0,
    ceil: this.maxPriceLabel.value,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return "" + value;
        case LabelType.High:
          if (this.maxPriceLabel.value == value)
            return this.maxPriceLabel.name;
          else
            return this.searchParams.max_amount;
        default:
          return "";
      }
    }
  };

  constructor(
    private helperService           : HelperService,
    private agentsService           : Agents,
    private authenticationService   : AuthenticationService,
    private formBuilder             : FormBuilder,
    private renderer                : Renderer2,
    private activatedRoute          : ActivatedRoute,

  ) {

    this.routerSubscription = this.activatedRoute.params.subscribe(routeParams => {
      this.custId = this.base64Pipe.decode(routeParams.custId);
      console.log("this.custId: ", this.custId);
  	});

    this.activeUser = this.authenticationService.get_currentUserValue();

    // Add Select Region Option
    if(this.activeUser.Portal_SuperAdmin)
      this.writersRegion.splice(0, 0, "");


    // Get Agents
    this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
      if (agents) {
        this.agents = agents.agents;

        this.select2Agents = [];
        let selectRegion = [{ label: 'Leads', val: '~' }, { label: 'Unpaid', val: 'unpaid_~' }, { label: 'CWHP', val: 'cwhp_~' }];
        for (let i = 0; i < selectRegion.length; i++) {
          for (let j = 0; j < this.agents.length; j++) {
            let agent = $.extend(true, {}, this.agents[j]);
            agent.region = selectRegion[i].label;
            agent.value = selectRegion[i].val + agent.id;
            this.select2Agents.push(agent);
          }
        }
        this.qa = agents.qa;
        this.writers = agents.writers;
      }
    });

    this.dtOptions = {
      paging: true,
      info: true,
      // ordering: false,
      pagingType: 'full_numbers',
      pageLength: 25,
      serverSide: true,
      processing: true,
      searching: false,
      'language': AppSettings.dataTableLang,
      "columnDefs": [
        { "orderable": false, "visible": true,                                                   "targets": 0  },
        { "orderable": true,  "visible": true,                                                   "targets": 1  },
        { "orderable": true,  "visible": true,                                                   "targets": 2  },
        { "orderable": false, "visible": true,                                                   "targets": 3  },
        { "orderable": false, "visible": true,                                                   "targets": 4  },
        { "orderable": true,  "visible": true,                                                   "targets": 5  },
        { "orderable": false, "visible": true,                                                   "targets": 6  },
        { "orderable": false, "visible": true,                                                   "targets": 7  },
      ],
      "order": [[1, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        // Show Loader
        this.loading = true;
        // console.log("dataTablesParameters", dataTablesParameters);

        let url = AppSettings.API_ENDPOINT + 'admin/order-management';;

        // // For Both SuperAdmin and QA
        // let url = AppSettings.API_ENDPOINT + 'admin/order-management';

        let dtParams = {
          lead           : this.searchParams.emailId,
          status         : this.searchParams.orderStatus,
          custId         : this.custId,
          // agent_id       : this.searchParams.agent_id,
          min_amount     : this.searchParams.min_amount,
          max_amount     : this.searchParams.max_amount,
          verified_sales : this.searchParams.verified_sales,
          date_from      : this.searchParams.date_from ? this.helperService.caonvertDateToString(this.searchParams.date_from) : '',
          date_to        : this.searchParams.date_to   ? this.helperService.caonvertDateToString(this.searchParams.date_to, false) : '',
          start          : dataTablesParameters.start,
          length         : dataTablesParameters.length,
          order          : dataTablesParameters.order,
          columns        : dataTablesParameters.columns,
        };

        // For Record Serial Numbers
        this.paginatePage = dataTablesParameters.start;

        // Empty Data
        this.leads = [];

        this.helperService.httpPostRequestsDecryp(url, dtParams)
          .then(resp => {
            this.leads        = JSON.parse(resp);
            this.leads_Copy   = $.extend(true, {}, this.leads);
            // console.log("this.leads", this.leads);

            // Set Default page len
            this.dtOptions.pageLength = this.dtElement['dt'].page.len();

            // Hide Loader
            this.loading = false;

            callback({
              recordsTotal: this.leads.total,
              recordsFiltered: this.leads.total,
              // recordsFiltered: resp['recordsFiltered'],
              // recordsFiltered: 1000,
              data: []
            });

            // // $(".paginate_button .current").css("color", "white");
            // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
            $('div.dataTables_length select').addClass('dt-form-control');
            $('div.dataTables_filter input').addClass('dt-form-control');
          })
          .catch(error => {
            // Set loader false
            this.loading = false;

            // // Rerender DT in case of failure
            // this.rerender();

            console.log("error: ", error);
          });
      },
      columns: [
        { data: 'id' },
        { data: 'id' },
        { data: 'date' },
        { data: 'name' },
        { data: 'price_noOfPages' },
        { data: 'delivery_date' },
        { data: 'assignedTo' },
        { data: 'orderStatus' }
      ],
      // Use this attribute to enable the responsive extension
      responsive: false
    }

  }


  ngOnInit() {
      this.addCommentForm = this.formBuilder.group({
        qaFeedback: [null, Validators.required],
      });
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();

    if (typeof this.agentsSub != 'undefined') {
      //prevent memory leak when component destroyed
      this.agentsSub.unsubscribe();
    }

    if (typeof this.routerSubscription != 'undefined') {
      //prevent memory leak when component destroyed
      this.routerSubscription.unsubscribe();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      // Destroy the table first
      dtInstance.destroy();

      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  splitFromTo() {
    console.log("this.fullRangeDate", this.fullRangeDate);

    if (this.fullRangeDate) {
      this.searchParams.date_from = this.fullRangeDate[0];
      this.searchParams.date_to = this.fullRangeDate[1];
    }
    this.rerender();
  }

  updateDesposition(lead, index) {
    let url = AppSettings.API_ENDPOINT + "admin/update-lead-status";
    let data = { id: lead.id, status: lead.status };
    this.helperService.httpPostRequests(url, data).then(resp => {
      if (typeof resp != "undefined") {
        // this.leads =
        // this.rerender();
      }
    });
  }

  parseFloatCustom(value) {
    return parseFloat(value);
  }

  agentSearch(id, agentArr) {
    for (var i = 0; i < agentArr.length; i++) {
      if (agentArr[i].id === id) {
        return agentArr[i].name;
      }
    }
  }

  showOrderStatus(id, statusArr) {
    for (var i = 0; i < statusArr.length; i++) {
      if (statusArr[i].value === id) {
        return statusArr[i].name;
      }
    }
  }

  showStatusColor(id, statusArr) {
    for (var i = 0; i < statusArr.length; i++) {
      if (statusArr[i].value === id) {
        return statusArr[i].color;
      }
    }
  }

  clearFilters() {
    this.searchParams = {
      emailId: '',
      disposition: null,
      agent_id: [],
      date_from: '',
      date_to: '',
      min_amount: 0,
      max_amount: this.maxPriceLabel.value
    };
    this.fullRangeDate = '';
    this.rerender();
  }

  totalPaymentSearch(id, despoArr) {
    for (var i = 0; i < despoArr.length; i++) {
      if (despoArr[i].value === id) {
        return despoArr[i].name;
      }
    }
  }

}
